import { Spinner } from '@iwoca/orion';

import { CheckoutComAddPaymentMethodForm } from './CheckoutComAddPaymentMethodForm';
import { StripeAddPaymentMethodForm } from './StripeAddPaymentMethodForm';
import { useSuspenseGetSelectPaymentProcessor } from '../../../../../api/lending/lapiHooks.suspense';

export const AddPaymentMethodForm = () => {
  const { paymentProcessor } = useSuspenseGetSelectPaymentProcessor();

  return paymentProcessor === 'Checkout' ? (
    <CheckoutComAddPaymentMethodForm />
  ) : (
    <StripeAddPaymentMethodForm />
  );
};

export const AddPaymentMethodFormSkeleton = () => {
  return (
    <div className="flex w-full justify-center">
      <Spinner />
    </div>
  );
};
